import './style.scss'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import { AppSpan, AppText, Circle, CustomContainer, FixedContainer, FlexColumn, FlexRow, Input } from "src/style";
import { CgMenuGridO } from "react-icons/cg";
//import {ReactComponent as Logo} from 'src/assets/img/qore-logo.svg'
import Logo from 'src/assets/img/Qstore-logo-white.png'
import { FiSearch } from 'react-icons/fi';
import { useContext, useState } from 'react';
import { BsBell } from 'react-icons/bs';
import ProfilePics from 'src/assets/img/profile-pics.jpg'
import { AccountAction, Menu, SearchableDropdown } from 'src/component';

export const Header: React.FC = () => {
    const {info: {userData}} = useContext(AppInfoContext)
    const [searchText, setSearchText] = useState('')
    const [view, setView] = useState('')

    const firstName = userData?.firstName || 'John'
    const lastName = userData?.firstName ? userData?.lastName : 'Doe'

    return (
        <>
            <FixedContainer 
                top="0" left="0" width="100" 
                sizeUnit="%" zIndex="3"
            >
                <CustomContainer 
                    height="13.7" bgColor="#101828" 
                    className="header-wrapper"
                >
                    <FlexRow 
                        justifyContent='space-between'
                        leftPadding="3" rightPadding="3"
                        height='7.2' gap='2'
                        className='header-search-container'
                    >
                        <FlexRow 
                            width='auto' sizeUnit='' gap='4'
                            className='header-logo-container'
                        >
                            <CgMenuGridO fontSize='2.5rem' color='#F7F8F9' />
                            {/* <Logo className='icon-component header-logo' /> */}
                            <CustomContainer 
                                height='3.6' width='13' overflow='auto'
                                bottomMargin='1.5' topMargin='1.3'
                                className='header-logo'
                            >
                                <img src={Logo} className='img-covered icon-component'/>
                            </CustomContainer>
                        </FlexRow>
                        {/* <CustomContainer
                            radius='0.8' borderColor='#344054'
                            leftPadding='1.5' rightPadding='1.5'
                            bgColor='#344054' width='51.9'
                            shadow='0px 1px 2px rgba(16, 24, 40, 0.05)'
                            className='header-search-box'
                        >
                            <FlexRow>
                                <FiSearch fontSize='1.5rem' color='#ffffff' />
                                <Input 
                                    height='4' leftPadding='1' color='#ffffff'
                                    placeholder='Search apps & services' 
                                    onChange={(e) => setSearchText(e.target.value)}
                                />
                            </FlexRow>
                        </CustomContainer> */}
                        <SearchableDropdown 
                            width={47}
                        />
                        <FlexRow 
                            width='auto' sizeUnit='' justifyContent='flex-start' gap='2.5'
                        >
                            <AppSpan textSize='2' color='#D0D5DD' >
                                <BsBell />
                            </AppSpan>
                            <Circle 
                                size="4" //bgColor='#F9FAFB'
                                bgColor='#0A756F'
                                style={{overflow: 'hidden'}}
                                onClick={() => setView('account-action')}
                            >
                                {/* <img src={ProfilePics} className='img-covered' /> */}
                                <AppText textSize='1.7' color='#ffffff' fontWeight='600' cursor='pointer'>{firstName?.[0]}{lastName?.[0]}</AppText>
                            </Circle>
                        </FlexRow>
                    </FlexRow>
                    <FlexColumn
                        leftPadding='9' rightPadding='3'
                        alignItems='flex-start' height='6.5'
                        className='scrollable-container menu-option-container'
                    >
                        <Menu />
                    </FlexColumn>
                </CustomContainer>
            </FixedContainer>
            { view === 'account-action' &&
                <AccountAction
                    close={() => setView('')} 
                />
            }
        </>
    )
}